/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../../hooks/useAuth'
import {
  logoutSaveToken,
  logoutService,
  redirectLogoutMicrosoft,
} from '../../features/auth/services/microsoft.service'
import {getLoadMasiveId} from '../../features/hoteleria/services/booking.service'

const KHeaderUserMenu: FC = () => {
  const {user, logout} = useAuth()

  const redirectLogout = (token: string) => {
    window.location.href = `${redirectLogoutMicrosoft}?q=${token}`
  }

  const handleLogout = async () => {
    try {
      const {metodoLogin, token} = user
      if (metodoLogin === 'microsoft') {
        const {data} = await getLoadMasiveId()
        const bulkLoadId = data.BulkLoadId
        const res = await logoutSaveToken({id: bulkLoadId, token: token})
        if (!res.data.error) {
          localStorage.removeItem('persist:root')
          redirectLogout(bulkLoadId)
        }
      } else {
        logout()
      }
    } catch (error) {
      console.error(error)
    }
  }
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/avatars/blank.png')} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5 text-truncate'>
              {user?.nombres}
            </div>
            <div className='fw-bolder d-flex align-items-center fs-5 text-truncate'>
              {user?.apellidoPaterno}
            </div>
          </div>
        </div>
        <div className='fw-bold text-muted text-hover-primary fs-7 text-truncate'>
          {user?.usuario}
        </div>
      </div>

      <div className='separator my-2'></div>

      {/* <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          Account Settings
        </Link>
      </div> */}

      <div className='menu-item px-5'>
        <a onClick={handleLogout} className='menu-link px-5'>
          Cerrar Sesion
        </a>
      </div>
    </div>
  )
}

export {KHeaderUserMenu}
